import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DiscountCodesData } from "../../api/discounts/index.types";

export interface DiscountCodesState {
  data: DiscountCodesData;
  loading: boolean;
}

const initialState: DiscountCodesState = {
  data: {
    discount_codes: [],
    count: 0,
    usedDiscountCodesWithFullDiscount: [],
  },
  loading: false,
};

const index = createSlice({
  name: "discountCodes",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action: PayloadAction<DiscountCodesData>) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
  },
});

export const discountCodesActions = index.actions;
export default index.reducer;
